/* eslint-disable camelcase */
type Semester = {
  is_open: boolean;
  add_drop_date: string;
  end_date: string;
  id: string;
  semester_name: string;
  final_assess_date: string;
  instructor_grading_deadline: string;
  competency_recording_deadline: string;
  overload_request_deadline?: string;
  start_date: string;
  university_code: string;
  university_name: string;
  label: string;
  value: string;
  year: string;
  term_ordinal: number;
  program_name?: string;
};

// export const DummyUser: User = {
//   name: 'Visarut',
//   lastname: 'Techatanachai
//   picture: 'https://picsum.photos/200',
// };

export const EmptySemesters: Array<Semester> = [];
export const EmptySemester: Semester = {
  is_open: false,
  add_drop_date: "",
  end_date: "",
  id: "",
  semester_name: "",
  final_assess_date: "",
  start_date: "",
  university_code: "",
  university_name: "",
  label: "",
  value: "",
  year: "",
  competency_recording_deadline: "",
  instructor_grading_deadline: "",
  term_ordinal: 0
};

export default Semester;
